import { render, staticRenderFns } from "./hogarPremiumSummary.vue?vue&type=template&id=125b5796&"
import script from "./hogarPremiumSummary.vue?vue&type=script&lang=ts&"
export * from "./hogarPremiumSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports